import { makeStyles } from '@mui/styles';
import Card from 'apollo-react/components/Card';
import IconButton from 'apollo-react/components/IconButton';
import Popover from 'apollo-react/components/Popover';
import Menu from 'apollo-react-icons/Menu';
import React, { useState } from 'react';

const useStyles = makeStyles({
  cardContent: {
    padding: 18,
    maxWidth: 200,
  },
});

const MenusBurger = ({ menus }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = ({ currentTarget }) => {
    setAnchorEl((prev) => (!prev ? currentTarget : null));
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <Menu />
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        PaperProps={{
          style: {
            boxShadow: '0 8px 20px 0 rgba(0, 0, 0, 0.08)',
          },
        }}
        onBackdropClick={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Card className={classes.cardContent}>{menus}</Card>
      </Popover>
    </>
  );
};

export default MenusBurger;
